<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import CatService from './CatService'
import Activity from './Activity'
import ComponentService from './ComponentService'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    CatService,
    Activity,
    ComponentService,
    McButtonBack,
    McButton,
  },

  computed: {
    title() {
      return this.$t('maintenance.title')
    },

    items() {
      return [
        {
          text: this.$t('global.setting'),
          to: '/setting/',
        },
        {
          text: this.$t('maintenance.breadCrumb.first'),
          to: '/setting/maintenance/',
        },
        {
          text: this.$t('maintenance.breadCrumb.second'),
          active: true,
        },
      ]
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <p class="mb-4">{{ $t('maintenance.label') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            icon="icon-fill_upload"
            :text="$t('global.action.upload')"
            variant="secondary"
            class="mx-2"
            @click="
              $router.push({
                name: 'Import Service Activity',
              })
            "
          />
          <McButtonBack href="/setting/maintenance/" />
        </div>
      </div>
    </div>

    <form>
      <b-card class="mc-card__setting">
        <b-tabs content-class="p-3 text-muted">
          <CatService status="CatService" ref="CatService" />
          <Activity status="Activity" ref="Activity" />
          <ComponentService status="ComponentService" ref="ComponentService" />
        </b-tabs>
      </b-card>
    </form>
  </Layout>
</template>
